// API service that switches between mock, Dataverse, and D1 APIs
// based on environment variables

import { mockApi } from './mockData';
import { dataverseApi, setAccessToken } from './dataverseApi';
import { d1Api } from './d1Api';

const isAuthEnabled = import.meta.env.VITE_ENABLE_AUTH === 'true';
const useD1Backend = import.meta.env.VITE_USE_D1 === 'true' || import.meta.env.VITE_API_URL;

// API client type - use mockApi as the canonical type
export type ApiClient = typeof mockApi;

// Export the appropriate API based on settings
// Priority: D1 > Dataverse > Mock
export const api: ApiClient = useD1Backend
  ? (d1Api as ApiClient)
  : isAuthEnabled
    ? (dataverseApi as ApiClient)
    : mockApi;

// Re-export setAccessToken for use by AuthProvider
export { setAccessToken };

// Legacy support - useApi hook returns the same api instance
export function useApi(): ApiClient {
  return api;
}
